import type { Manufacturer } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/asset/manufacturer/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

export const createFields: FormItem<Manufacturer>[] = [
  {
    cssClass: 'tmm-section-no-background',
    caption: 'Manufacturer Details',
    colCount: 2,
    items: [allFields.tenantId],
  },
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: 3,
    items: [
      { ...allFields.name, colSpan: 3 },
      { ...allFields.contactPerson, colSpan: 1 },
      { ...allFields.contactEmail, colSpan: 1 },
      { ...allFields.contactPhone, colSpan: 1 },
      { ...allFields.description, colSpan: 3 },
    ],
  },
  {
    cssClass: 'tmm-section',
    caption: 'Address',
    colCount: 1,
    items: [
      { ...allFields.countryId, colSpan: 1 },
      { ...allFields.address, colSpan: 1 },
    ],
  },
  {
    cssClass: 'tmm-section',
    caption: 'Resources',
    colCount: 3,
    items: [
      allFields.website,
      allFields.vendorPortalLink,
      allFields.warrantyPolicies,
      { ...allFields.slaDetails, colSpan: 3 },
    ],
  },
];

export const updateFields: FormItem<Manufacturer>[] = [
  {
    cssClass: 'tmm-section-no-background',
    caption: 'Manufacturer Details',
    colCount: 2,
    items: [allFields.tenantId],
  },
  {
    cssClass: 'tmm-section  tmm-section-no-caption',
    colCount: 6,
    items: [
      { ...allFields.name, colSpan: 3 },
      { ...allFields.inUseStatus, colSpan: 3 },
      { ...allFields.contactPerson, colSpan: 2 },
      { ...allFields.contactEmail, colSpan: 2 },
      { ...allFields.contactPhone, colSpan: 2 },
      { ...allFields.description, colSpan: 6 },
    ],
  },
  {
    cssClass: 'tmm-section',
    caption: 'Address',
    colCount: 1,
    items: [
      { ...allFields.countryId, colSpan: 1 },
      { ...allFields.address, colSpan: 1 },
    ],
  },
  {
    cssClass: 'tmm-section',
    caption: 'Resources',
    colCount: 3,
    items: [
      allFields.website,
      allFields.vendorPortalLink,
      allFields.warrantyPolicies,
      { ...allFields.slaDetails, colSpan: 3 },
    ],
  },
  getHistorySection(),
];
